import { defineStore, createPinia } from 'pinia'
import { GlobalState, ThemeConfigProp } from './interface/index.module'
import { DEFAULT_PRIMARY } from '@/config/config'
import piniaPersistConfig from '@/config/piniaPersist'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { DbUser } from '@/api/interface/dbUser.model'
import { ref } from 'vue'
import { Router, RouteRecordNormalized } from 'vue-router'

// defineStore 调用后返回一个函数，调用该函数获得 Store 实体
export const GlobalStore = defineStore('GlobalState', {
  // state: 返回对象的函数
  state: (): GlobalState => ({
    // token
    token: '',
    // userinfo
    userinfo: {} as DbUser.DbUserinfo,
    // user-account
    userAccount: '',
    // isRemember
    isRemember: [''],
    // element组件大小
    assemblySize: 'default',
    // language
    language: '',
    // themeConfig
    themeConfig: {
      // 布局切换 ==>  纵向：vertical | 经典：classic | 横向：transverse | 分栏：columns
      layout: 'vertical',
      // 默认 primary 主题颜色
      primary: DEFAULT_PRIMARY,
      // 深色模式
      isDark: false,
      // 灰色模式
      isGrey: false,
      // 色弱模式
      isWeak: false,
      // 面包屑导航
      breadcrumb: true,
      // 标签页
      tabs: false,
      // 页脚
      footer: false
    },
    // 存放列表
    list: [],
    // 列表数据总数
    total: 0,
    // 路由信息处理
    router: [] as RouteRecordNormalized[],
    /**音乐列表 */
    musicList: []
  }),
  getters: {
    getUserAccount(): string {
      return this.userAccount
    },
    getIsRemember(): (string | boolean)[] {
      return this.isRemember
    }
  },
  actions: {
    // setToken
    setToken(token: string) {
      this.token = token
      //token变化需socket重连
      // MetaSocket.close();
      // if (token) {
      // 	MetaSocket.reconnect();
      // }
    },
    // getToken
    getToken(): string {
      return this.token
    },
    removeToken() {
      this.token = ''
    },
    getUserinfo(): DbUser.DbUserinfo {
      return this.userinfo
    },
    getRouter(): RouteRecordNormalized {
      return this.router
    },
    // 记住账密
    setUserAccount(userAccount: string) {
      this.userAccount = userAccount
    },
    removeUserAccount() {
      this.userAccount = ''
    },
    setIsRemember(isRemember: (string | boolean)[]) {
      this.isRemember = isRemember
    },
    removeIsRemember() {
      this.isRemember = ''
    },
    // setUserinfo
    setUserinfo(userinfo: DbUser.DbUserinfo) {
      this.userinfo = userinfo
    },
    // setAssemblySizeSize
    setAssemblySizeSize(assemblySize: string) {
      this.assemblySize = assemblySize
    },
    // updateLanguage
    updateLanguage(language: string) {
      this.language = language
    },
    // setThemeConfig
    setThemeConfig(themeConfig: ThemeConfigProp) {
      this.themeConfig = themeConfig
    },
    // setdepositList
    setlist(list: []) {
      this.list = list
    },
    // setdepositTotal
    setTotal(total: number) {
      this.total = total
    },
    // 处理路由信息
    dealRouter(router: Router, first: string) {
      // 处理路由，抛去不必要的部分
      const routerArray = ref<RouteRecordNormalized[]>()

      switch (first) {
        case '角色':
          routerArray.value = router.getRoutes().filter((item) => item.meta.first === '角色')
          break
        case '权限':
          routerArray.value = router.getRoutes().filter((item) => item.meta.first === '权限')
          break
        case '资源':
          routerArray.value = router.getRoutes().filter((item) => item.meta.first === '资源')
          break
        case '财务':
          routerArray.value = router.getRoutes().filter((item) => item.meta.first === '财务')
          break
        case '配置':
          routerArray.value = router.getRoutes().filter((item) => item.meta.first === '配置')
          break
        case '工作台':
          routerArray.value = router.getRoutes().filter((item) => item.meta.first === '工作台')
          break
      }

      // 路由为空
      if (!routerArray.value) {
        this.router = []
        return
      }
      // 构建一级和二级菜单项
      const firstLevelMenuItems = ref(
        routerArray.value.reduce(
          (acc, item) => {
            const firstLevel = acc.find((level) => level.second === item.meta.second)
            if (firstLevel) {
              firstLevel.secondLevelItems.push(item)
            } else {
              acc.push({
                second: item.meta.second as string,
                icon: item.meta.icon as string,
                secondLevelItems: [item]
              })
            }
            return acc
          },
          [] as Array<{ second: string; icon: string; secondLevelItems: typeof routerArray.value }>
        )
      )
      this.router = firstLevelMenuItems.value
    }
  },
  persist: piniaPersistConfig(import.meta.env.VITE_META_CODE + 'GlobalState')
})

// piniaPersist(持久化)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

export default pinia
